import { render, staticRenderFns } from "./PublicThought.vue?vue&type=template&id=0a71350a&scoped=true&"
import script from "./PublicThought.vue?vue&type=script&lang=js&"
export * from "./PublicThought.vue?vue&type=script&lang=js&"
import style0 from "./PublicThought.vue?vue&type=style&index=0&id=0a71350a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a71350a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBadge,VCard,VListItem,VListItemContent,VListItemTitle})
